(() => {
  const initialise = (root) => {
    if (!root || root.dataset.altoffInfoReady === 'true') return;
    root.dataset.altoffInfoReady = 'true';

    const items = Array.from(root.querySelectorAll('[data-altoff-accordion]'));

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-altoff-info]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseAll(event.target);
  });
})();
